 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		49: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		49: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~ActivationFlow~BuyFlow~CalculatorWidget~CaseManagementWidget~EshopLeasingDetailsView~HomeInt~fdb280c4","1":"vendors~AISASection~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWi~f55fa7a8","2":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~Product~3a563968","3":"vendors~ActivationFlow~BuyFlow~InstantPay~MessageWidgetFlow~OtpWidget~RedemptionFlow~SOGGiftCardDeta~3aa99e43","4":"CalculatorWidget~EshopLeasingDetailsView~HomeInternetFilter~InstantPay~ProductDetailsView~SpotifyBuy~a8a96964","5":"FaqComponent~PricePlanCards~ProductListingCategory~SubscriptionPage","9":"EshopLeasingDetailsView~ProductDetailsView","10":"MessageWidgetFlow","11":"vendors~FaqComponent~ProductListingCategory","12":"vendors~InstantPay~SpotifyBuyflowWidget","14":"AISASection","15":"ActivationFlow","16":"BuyFlow","17":"CalculatorWidget","18":"CaseManagementWidget","19":"EshopLeasingCatalogue","20":"EshopLeasingDetailsView","21":"FaqComponent","22":"GECheckUsageWidget","23":"GERoiForm","24":"HomeInternetFilter","25":"InstantPay","26":"MobileInternetFilter","27":"OtpWidget","28":"PickAndGoWidget","29":"PlanSelectionView","30":"PricePlanCards","31":"ProductCardCatalogue","32":"ProductDetailsView","33":"ProductListingCategory","34":"PromotionsWidget","35":"RedemptionFlow","36":"SAPDealsWidget","37":"SOGCardCatalogue","38":"SOGGiftCardDetails","39":"SOGRecommendations","40":"SpotifyBuyflowWidget","41":"StoreLocator","42":"SubscriptionFlow","43":"SubscriptionPage","44":"TradeInWidget","45":"TransactionResult","46":"VasMessageWidgetFlow","47":"WebSearchBar","50":"vendors~AISASection","51":"vendors~GECheckUsageWidget","52":"vendors~GERoiForm","53":"vendors~HomeInternetFilter","54":"vendors~MobileInternetFilter","55":"vendors~PickAndGoWidget","56":"vendors~PricePlanCards","57":"vendors~StoreLocator","58":"vendors~SubscriptionPage","59":"vendors~TradeInWidget","60":"vendors~WebSearchBar"}[chunkId]||chunkId) + "." + {"0":"22397e91","1":"b591394d","2":"b26e1726","3":"51ebe96c","4":"5cb62ea5","5":"544b0694","6":"e746f5ec","7":"12d7b8bd","8":"5d9922f0","9":"85a5428d","10":"03ad0151","11":"caf55dba","12":"3a633253","13":"678dcaa0","14":"82608c11","15":"e2b3d0c4","16":"23c05f63","17":"c2e4d59d","18":"6d9945e6","19":"0ec13638","20":"1ad22cfe","21":"cf85820a","22":"b279515a","23":"7a34ea1f","24":"5f77e3a8","25":"eb2a7202","26":"e24bf88b","27":"226a4a57","28":"30bfb4d3","29":"55b83673","30":"5e8f1807","31":"9aca81cc","32":"c16d9637","33":"d6de14b1","34":"9710924f","35":"a672b213","36":"8cbea123","37":"91c46d94","38":"aab25fe7","39":"62a72b6e","40":"4564fb31","41":"b77957f1","42":"b922fd93","43":"4ea4b273","44":"ff35b780","45":"de3ebd5d","46":"3119f9b0","47":"a657a128","50":"dd0686c0","51":"659983c8","52":"8c453874","53":"ff951721","54":"4ee46565","55":"8c046145","56":"a4f11684","57":"c1fc2a3d","58":"a5d8a5f4","59":"5adbf8f6","60":"624d6107","61":"42e3f840","62":"b89476db"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"38":1,"56":1,"60":1,"61":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~ActivationFlow~BuyFlow~CalculatorWidget~CaseManagementWidget~EshopLeasingDetailsView~HomeInt~fdb280c4","1":"vendors~AISASection~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWi~f55fa7a8","2":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~Product~3a563968","3":"vendors~ActivationFlow~BuyFlow~InstantPay~MessageWidgetFlow~OtpWidget~RedemptionFlow~SOGGiftCardDeta~3aa99e43","4":"CalculatorWidget~EshopLeasingDetailsView~HomeInternetFilter~InstantPay~ProductDetailsView~SpotifyBuy~a8a96964","5":"FaqComponent~PricePlanCards~ProductListingCategory~SubscriptionPage","9":"EshopLeasingDetailsView~ProductDetailsView","10":"MessageWidgetFlow","11":"vendors~FaqComponent~ProductListingCategory","12":"vendors~InstantPay~SpotifyBuyflowWidget","14":"AISASection","15":"ActivationFlow","16":"BuyFlow","17":"CalculatorWidget","18":"CaseManagementWidget","19":"EshopLeasingCatalogue","20":"EshopLeasingDetailsView","21":"FaqComponent","22":"GECheckUsageWidget","23":"GERoiForm","24":"HomeInternetFilter","25":"InstantPay","26":"MobileInternetFilter","27":"OtpWidget","28":"PickAndGoWidget","29":"PlanSelectionView","30":"PricePlanCards","31":"ProductCardCatalogue","32":"ProductDetailsView","33":"ProductListingCategory","34":"PromotionsWidget","35":"RedemptionFlow","36":"SAPDealsWidget","37":"SOGCardCatalogue","38":"SOGGiftCardDetails","39":"SOGRecommendations","40":"SpotifyBuyflowWidget","41":"StoreLocator","42":"SubscriptionFlow","43":"SubscriptionPage","44":"TradeInWidget","45":"TransactionResult","46":"VasMessageWidgetFlow","47":"WebSearchBar","50":"vendors~AISASection","51":"vendors~GECheckUsageWidget","52":"vendors~GERoiForm","53":"vendors~HomeInternetFilter","54":"vendors~MobileInternetFilter","55":"vendors~PickAndGoWidget","56":"vendors~PricePlanCards","57":"vendors~StoreLocator","58":"vendors~SubscriptionPage","59":"vendors~TradeInWidget","60":"vendors~WebSearchBar"}[chunkId]||chunkId) + "." + {"0":"22397e91","1":"b591394d","2":"b26e1726","3":"51ebe96c","4":"5cb62ea5","5":"544b0694","6":"e746f5ec","7":"12d7b8bd","8":"5d9922f0","9":"85a5428d","10":"03ad0151","11":"caf55dba","12":"3a633253","13":"678dcaa0","14":"82608c11","15":"e2b3d0c4","16":"23c05f63","17":"c2e4d59d","18":"6d9945e6","19":"0ec13638","20":"1ad22cfe","21":"cf85820a","22":"b279515a","23":"7a34ea1f","24":"5f77e3a8","25":"eb2a7202","26":"e24bf88b","27":"226a4a57","28":"30bfb4d3","29":"55b83673","30":"5e8f1807","31":"9aca81cc","32":"c16d9637","33":"d6de14b1","34":"9710924f","35":"a672b213","36":"8cbea123","37":"91c46d94","38":"aab25fe7","39":"62a72b6e","40":"4564fb31","41":"b77957f1","42":"b922fd93","43":"4ea4b273","44":"ff35b780","45":"de3ebd5d","46":"3119f9b0","47":"a657a128","50":"dd0686c0","51":"659983c8","52":"8c453874","53":"ff951721","54":"4ee46565","55":"8c046145","56":"a4f11684","57":"c1fc2a3d","58":"a5d8a5f4","59":"5adbf8f6","60":"624d6107","61":"42e3f840","62":"b89476db"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.aws.singtel.com/lux/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
